import { render, staticRenderFns } from "./AddMessageLetter.vue?vue&type=template&id=51e18599&scoped=true&"
import script from "./AddMessageLetter.vue?vue&type=script&lang=ts&"
export * from "./AddMessageLetter.vue?vue&type=script&lang=ts&"
import style0 from "./AddMessageLetter.vue?vue&type=style&index=0&id=51e18599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e18599",
  null
  
)

export default component.exports